export { default } from './CoLoginBannerLarge'
